import { Alert, AlertTitle, Box } from "@mui/material";
import { Edit, Loading } from "react-admin";
import { useGroupEdit } from "./hooks/useGroupEdit";
import GroupEditForm from "./GroupEditForm";

export const GroupEdit = () => {
  return (
    <Edit>
      <GroupEditContainer />
    </Edit>
  );
};

const GroupEditContainer = () => {
  const { error, isLoading, handleSubmit } = useGroupEdit();

  if (isLoading) return <Loading />;

  return (
    <>
      {error && (
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          <Box>
            {error?.message}
            <br />
            {error?.response?.data && (error.response.data as any)?.detail}
          </Box>
        </Alert>
      )}
      <GroupEditForm handleSubmit={handleSubmit} />
    </>
  );
};
